<div class="header-container">
  <div class="header-item"><img src="./assets/logo1.png" alt="Wicked Infinity Publishing Logo"></div>
  <div class="header-item">
    <h1 class="header-item">Admin Dashboard</h1>
  </div>
  <div class="header-item" *ngIf="authService.userData as user">{{user.email}}<br>
    <input type="submit" class="header-item" value="Log Out" (click)="this.signOut()">
    <input type="submit" class="header-item" value="Reset Password" (click)="authService.resetPassword(user.email)">
  </div>
</div>
<mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start">
  <mat-tab
    [disabled]="authorService.keepFocus || bookService.keepFocus || blogService.keepFocus || eventService.keepFocus || statsService.keepFocus"
    label="Authors"><app-authors></app-authors></mat-tab>
  <mat-tab
    [disabled]="authorService.keepFocus || bookService.keepFocus || blogService.keepFocus || eventService.keepFocus || statsService.keepFocus"
    label="Books"><app-books></app-books></mat-tab>
  <mat-tab
    [disabled]="authorService.keepFocus || bookService.keepFocus || blogService.keepFocus || eventService.keepFocus || statsService.keepFocus"
    label="Blog"><app-blog-posts></app-blog-posts></mat-tab>
  <mat-tab
    [disabled]="authorService.keepFocus || bookService.keepFocus || blogService.keepFocus || eventService.keepFocus || statsService.keepFocus"
    label="Events"><app-events></app-events></mat-tab>
  <mat-tab
    [disabled]="authorService.keepFocus || bookService.keepFocus || blogService.keepFocus || eventService.keepFocus || statsService.keepFocus"
    label="Stats"><app-stats></app-stats></mat-tab>
</mat-tab-group>